import { render, staticRenderFns } from "./SetCustomFlag.vue?vue&type=template&id=8dc41d3a&"
import script from "./SetCustomFlag.vue?vue&type=script&lang=js&"
export * from "./SetCustomFlag.vue?vue&type=script&lang=js&"
import style0 from "./SetCustomFlag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports